/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HighScoringMatchInfo } from './HighScoringMatchInfo';
import {
    HighScoringMatchInfoFromJSON,
    HighScoringMatchInfoFromJSONTyped,
    HighScoringMatchInfoToJSON,
    HighScoringMatchInfoToJSONTyped,
} from './HighScoringMatchInfo';

/**
 * 
 * @export
 * @interface MatchStatistics
 */
export interface MatchStatistics {
    /**
     * 
     * @type {number}
     * @memberof MatchStatistics
     */
    totalMatches?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchStatistics
     */
    completedMatches?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchStatistics
     */
    totalGoals?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchStatistics
     */
    averageGoalsPerMatch?: number;
    /**
     * 
     * @type {HighScoringMatchInfo}
     * @memberof MatchStatistics
     */
    highestScoringMatch?: HighScoringMatchInfo;
}

/**
 * Check if a given object implements the MatchStatistics interface.
 */
export function instanceOfMatchStatistics(value: object): value is MatchStatistics {
    return true;
}

export function MatchStatisticsFromJSON(json: any): MatchStatistics {
    return MatchStatisticsFromJSONTyped(json, false);
}

export function MatchStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchStatistics {
    if (json == null) {
        return json;
    }
    return {
        
        'totalMatches': json['totalMatches'] == null ? undefined : json['totalMatches'],
        'completedMatches': json['completedMatches'] == null ? undefined : json['completedMatches'],
        'totalGoals': json['totalGoals'] == null ? undefined : json['totalGoals'],
        'averageGoalsPerMatch': json['averageGoalsPerMatch'] == null ? undefined : json['averageGoalsPerMatch'],
        'highestScoringMatch': json['highestScoringMatch'] == null ? undefined : HighScoringMatchInfoFromJSON(json['highestScoringMatch']),
    };
}

export function MatchStatisticsToJSON(json: any): MatchStatistics {
    return MatchStatisticsToJSONTyped(json, false);
}

export function MatchStatisticsToJSONTyped(value?: MatchStatistics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalMatches': value['totalMatches'],
        'completedMatches': value['completedMatches'],
        'totalGoals': value['totalGoals'],
        'averageGoalsPerMatch': value['averageGoalsPerMatch'],
        'highestScoringMatch': HighScoringMatchInfoToJSON(value['highestScoringMatch']),
    };
}

